export interface RequestStatusInfo {
    creationDate: number;
    eventExecutorType: number;
    percentage: number;
    requestDetails: string;
    requestNumber: number;
    resultLink: string;
    status: LongRequestStatus;
}

export const LONG_REQUEST_STATUSES = ['Not Started', 'In Progress', 'Completed', 'Failed'] as const;
export type LongRequestStatus = typeof LONG_REQUEST_STATUSES[number];
